import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import LineSeperator from '../ui/LineSeperator';
import AdmissionNotice from './AdmissionNotice';
import NormalNotice from './NormalNotice';
import '../../stylings/Notices.css';

export default function Notices() {
  return (
    <section className="notices-section">
      <div className="container-fluid px-5">
        <LineSeperator title="News & Notices" />
        <div className="row g-4 mt-2">
          <div className="col-lg-4">
            <AdmissionNotice />
          </div>
          <div className="col-lg-4">
            <NormalNotice />
          </div>
          <div className="col-lg-4">
            <SchoolCalendarWidget />
          </div>
        </div>
      </div>
    </section>
  );
}

function SchoolCalendarWidget() {
  const events = [
    { date: '2025-04-14', title: 'Dr. B.R. Ambedkar Jayanti', type: 'Holiday' },
    { date: '2025-05-01', title: 'Labour Day', type: 'Holiday' },
    { date: '2025-06-15', title: 'Annual Sports Meet', type: 'Event' },
    { date: '2025-07-20', title: 'Parent-Teacher Meeting', type: 'PTM' },
    { date: '2025-08-15', title: 'Independence Day', type: 'Holiday' },
    { date: '2025-10-02', title: 'Gandhi Jayanti', type: 'Holiday' },
  ];

  return (
    <div className="notice-widget">
      <div className="notice-widget-header calendar-header">
        <i className="fas fa-calendar-alt me-2"></i> School Calendar
      </div>
      <div className="notice-widget-body">
        <ul className="calendar-event-list">
          {events.map((ev, i) => (
            <li key={i} className="calendar-event-item">
              <div className={`cal-date-badge cal-${ev.type.toLowerCase()}`}>
                <span className="cal-day">{moment(ev.date).format('DD')}</span>
                <span className="cal-month">{moment(ev.date).format('MMM')}</span>
              </div>
              <div className="cal-event-info">
                <p className="cal-event-title">{ev.title}</p>
                <span className={`cal-event-type type-${ev.type.toLowerCase()}`}>{ev.type}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className="notice-widget-footer">
        <Link to="/academic-calendar">View Full Calendar →</Link>
      </div>
    </div>
  );
}
